import { Flex, Range, Text } from "src/elements";

interface Props {
  title: string;
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
  isDisabled?: boolean;
  leftLabel?: string;
  rightLabel?: string;
}

export const RuleRange = ({
  title,
  min,
  max,
  step,
  value,
  setValue,
  isDisabled,
  leftLabel,
  rightLabel,
}: Props) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
        {title}
      </Text>

      <Range
        min={min}
        max={max}
        step={step}
        value={value}
        setValue={setValue}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        isDisabled={isDisabled}
      />
    </Flex>
  );
};
